import {object, string} from 'yup'

export const GroupSchema = object().shape({
  name: string().required('Group name is required!')
})

export const GroupPrototype = {
  name: '',
  rotationInterval: 30
}
